module.exports = {
	"genre": {
		"genre-id-1": "Diversos",
		"genre-id-2": "Blues/Country/Folk",
		"genre-id-3": "Blues",
		"genre-id-4": "Country",
		"genre-id-5": "Folk",
		"genre-id-6": "Chanson française",
		"genre-id-7": "Intérpretes de chanson française",
		"genre-id-8": "Chanson française retrô",
		"genre-id-9": "Rock francês",
		"genre-id-10": "Clássica",
		"genre-id-11": "Eletrônica ou concreta",
		"genre-id-12": "Música concreta",
		"genre-id-13": "Música eletrônica",
		"genre-id-14": "Música minimalista",
		"genre-id-15": "Melodias e Lieder",
		"genre-id-16": "Lieder (Alemanha)",
		"genre-id-17": "Lieder",
		"genre-id-18": "Melodias",
		"genre-id-19": "Melodias (Inglaterra)",
		"genre-id-20": "Melodias (Norte da Europa)",
		"genre-id-21": "Melodias (França)",
		"genre-id-22": "Música de concerto",
		"genre-id-23": "Outros instrumentos",
		"genre-id-24": "Concertos para teclado",
		"genre-id-25": "Concertos para violino",
		"genre-id-26": "Concertos para violoncelo",
		"genre-id-27": "Música de câmara",
		"genre-id-28": "Outras formações",
		"genre-id-29": "Outros instrumentos solo",
		"genre-id-30": "Piano solo",
		"genre-id-31": "Quartetos",
		"genre-id-32": "Quintetos",
		"genre-id-33": "Duetos",
		"genre-id-34": "Trios",
		"genre-id-35": "Violino solo",
		"genre-id-36": "Violoncelo solo",
		"genre-id-37": "Música sinfônica",
		"genre-id-38": "Balés",
		"genre-id-39": "Música cênica",
		"genre-id-40": "Música cinematográfica",
		"genre-id-41": "Aberturas",
		"genre-id-42": "Poemas sinfônicos",
		"genre-id-43": "Sinfonias",
		"genre-id-44": "Música vocal (profana e sagrada)",
		"genre-id-45": "Cantatas (profanas)",
		"genre-id-46": "Música coral (para coro)",
		"genre-id-47": "Música para ensembles vocais",
		"genre-id-48": "Oratórios profanos",
		"genre-id-49": "Recitais vocais",
		"genre-id-50": "Música vocal sagrada",
		"genre-id-51": "Cantatas sagradas",
		"genre-id-52": "Corais sagrados",
		"genre-id-53": "Missas, Paixões, Requiems",
		"genre-id-54": "Oratórios sagrados",
		"genre-id-55": "Ópera",
		"genre-id-56": "Trechos de ópera",
		"genre-id-57": "Ópera completa",
		"genre-id-58": "Opereta",
		"genre-id-59": "Recitação",
		"genre-id-60": "Pedagogia",
		"genre-id-61": "Documentos históricos",
		"genre-id-62": "Humor",
		"genre-id-63": "Literatura",
		"genre-id-64": "Eletrônica",
		"genre-id-65": "Ambiente",
		"genre-id-66": "Downtempo",
		"genre-id-67": "Drum & Bass",
		"genre-id-68": "House",
		"genre-id-69": "Lounge",
		"genre-id-70": "Techno",
		"genre-id-71": "Trance",
		"genre-id-72": "Trip Hop",
		"genre-id-73": "Infantil - Ambiente",
		"genre-id-74": "Acordeão",
		"genre-id-75": "Contos e canções de ninar",
		"genre-id-76": "Educativo",
		"genre-id-77": "Karaokê",
		"genre-id-78": "Música militar",
		"genre-id-79": "Relaxamento",
		"genre-id-80": "Jazz",
		"genre-id-81": "Be Bop",
		"genre-id-82": "Cool jazz",
		"genre-id-83": "Free jazz & Avant-garde",
		"genre-id-84": "Gospel",
		"genre-id-85": "Jazz contemporâneo",
		"genre-id-86": "Jazz fusion & Jazz rock",
		"genre-id-87": "Gypsy jazz",
		"genre-id-88": "Jazz tradicional & New Orleans",
		"genre-id-89": "Jazz vocal",
		"genre-id-90": "Jazz latino",
		"genre-id-91": "Trilhas Sonoras",
		"genre-id-92": "Trilhas sonoras de filmes",
		"genre-id-93": "Musicais",
		"genre-id-94": "World music",
		"genre-id-95": "África",
		"genre-id-96": "Afrobeat",
		"genre-id-97": "Ásia",
		"genre-id-98": "Brasilidades",
		"genre-id-99": "Celta",
		"genre-id-100": "Leste Europeu",
		"genre-id-101": "Fado",
		"genre-id-102": "Flamenco",
		"genre-id-103": "Música étnica",
		"genre-id-104": "Música indiana",
		"genre-id-105": "Oriente",
		"genre-id-106": "Raï",
		"genre-id-107": "Salsa",
		"genre-id-108": "Tango",
		"genre-id-109": "World Music",
		"genre-id-110": "Yiddish & Klezmer",
		"genre-id-111": "Zouk & Antilhas",
		"genre-id-112": "Pop/Rock",
		"genre-id-113": "Alternativo & Indie",
		"genre-id-114": "Crooners",
		"genre-id-115": "Hard Rock",
		"genre-id-116": "Metal",
		"genre-id-117": "Pop",
		"genre-id-118": "Punk - New Wave",
		"genre-id-119": "Rock",
		"genre-id-120": "Rock progressivo",
		"genre-id-121": "Rockabilly",
		"genre-id-122": "Variedade internacional",
		"genre-id-123": "Reggae",
		"genre-id-124": "Dancehall",
		"genre-id-125": "Dub",
		"genre-id-126": "Ska & Rocksteady",
		"genre-id-127": "Soul/Funk/R&B",
		"genre-id-128": "Acid jazz",
		"genre-id-129": "Dance",
		"genre-id-130": "Disco",
		"genre-id-131": "Funk",
		"genre-id-132": "R&B",
		"genre-id-133": "Hip-Hop/Rap",
		"genre-id-134": "Soul",
		"genre-id-135": "Opereta",
		"genre-id-137": "Concertos para trompete",
		"genre-id-138": "Concertos para instrumentos de sopro",
		"genre-id-139": "Crossover",
		"genre-id-140": "Documentos",
		"genre-id-141": "New Age",
		"genre-id-142": "Ambiente",
		"genre-id-144": "Crossover",
		"genre-id-145": "Dixieland",
		"genre-id-146": "Ragtime",
		"genre-id-147": "Seriados",
		"genre-id-148": "Videogame",
		"genre-id-149": "América Latina",
		"genre-id-150": "América do Norte",
		"genre-id-151": "Europa",
		"genre-id-152": "Cigana",
		"genre-id-153": "Música tradicional",
		"genre-id-154": "Magrebe",
		"genre-id-155": "Rússia",
		"genre-id-156": "Turquia",
		"genre-id-157": "Indie pop",
		"genre-id-158": "Canções cômicas",
		"genre-id-159": "Músicas de Natal",
		"genre-id-160": "Música alemã",
		"genre-id-161": "Escócia",
		"genre-id-162": "Espanha",
		"genre-id-163": "Grécia",
		"genre-id-164": "Irlanda",
		"genre-id-165": "Música italiana",
		"genre-id-166": "Portugal",
		"genre-id-167": "Infantil",
		"genre-id-176": "Música vocal profana",
		"genre-id-173": "Schlager",
		"genre-id-171": "Stimmungsmusik",
		"genre-id-172": "Volksmusik",
		"genre-id-174": "Música celta irlandesa",
		"genre-id-175": "Música pop irlandesa",
		"genre-id-168": "Música folclórica suíça",
		"genre-id-178": "Alemão",
		"genre-id-177": "Inglês",
		"genre-id-170": "Francês",
		"genre-id-179": "Holandês",
		"genre-id-180": "Bolero",
		"genre-id-181": "Latina",
		"genre-id-182": "Reggaeton",
		"genre-id-183": "MPB",
		"genre-id-184": "Bossa Nova",
		"genre-id-185": "Samba",
		"genre-id-186": "Forró",
		"genre-id-187": "Pagode",
		"genre-id-188": "Funk Brasileiro",
		"genre-id-189": "Sertanejo",
		"genre-id-190": "Música japonesa",
		"genre-id-191": "J-Pop",
		"genre-id-192": "Música tradicional japonesa",
		"genre-id-193": "Música coreana",
		"genre-id-194": "K-Pop",
		"genre-id-195": "Música tradicional coreana",
		"genre-id-196": "Anime/Vídeo Game",
		"genre-id-197": "Anime"
	},
	"article-cat": {
		"article-cat-2": "-- ARQUIVOS GERAIS --",
		"article-cat-4": "Encontros",
		"article-cat-5": "-- ARQUIVOS GER / LER / CLÁSSICA --",
		"article-cat-7": "No palco",
		"article-cat-8": "Indicações e Prêmios",
		"article-cat-10": "Nas mídias",
		"article-cat-22": "Obituário",
		"article-cat-51": "Discografia",
		"article-cat-53": "Bibliografia",
		"article-cat-54": "Retratos",
		"article-cat-97": "Notícias",
		"article-cat-98": "Seções principais",
		"article-cat-100": "Indústrias",
		"article-cat-101": "Novidades",
		"article-cat-117": "JazzNews",
		"article-cat-122": "Notícias",
		"article-cat-189": "Entrevista",
		"article-cat-197": "Escuta comparada",
		"article-cat-199": "Encontros",
		"article-cat-209": "Minha memória canta",
		"article-cat-226": "Cave Canem",
		"article-cat-227": "Fortissimo",
		"article-cat-229": "Você pode?",
		"article-cat-238": "Revista: críticas",
		"article-cat-252": "Callassotherapy",
		"article-cat-260": "O sinfômano",
		"article-cat-267": "Cruzamentos",
		"article-cat-279": "Concertos",
		"article-cat-286": "Confidencial",
		"article-cat-287": "Agenda",
		"article-cat-293": "Eventos",
		"article-cat-295": "Concertos e turnês",
		"article-cat-297": "Hi-Fi",
		"article-cat-298": "Bancos de teste",
		"article-cat-299": "Prática",
		"article-cat-301": "Atualidades",
		"article-cat-302": "Gravações excepcionais",
		"article-cat-303": "Os Mágicos do Som",
		"article-cat-304": "Trax",
		"article-cat-305": "Antigos clássicos com nova roupagem",
		"article-cat-306": "Voxpop",
		"article-cat-311": "Orquestra Filarmônica de Berlim",
		"article-cat-312": "André Tubeuf: Memória e Paisagens",
		"article-cat-315": "François Hudry : Cum grano salis",
		"article-cat-316": "Qibuz Clássico",
		"article-cat-318": "Os editoriais",
		"article-cat-319": "Qobuz em",
		"article-cat-320": "Marselha",
		"article-cat-321": "Festival Paris Baroque",
		"article-cat-322": "Os doidos da Hi-Fi",
		"article-cat-323": "Rennes",
		"article-cat-324": "Editoriais",
		"article-cat-325": "Qibuz",
		"article-cat-326": "O editorial de Jean-Michel Proust",
		"article-cat-327": "Jean-Michel Proust: o destaque do mês",
		"article-cat-328": "Qibuz Segunda-Feira",
		"article-cat-329": "Lille",
		"article-cat-330": "Yes Masters !",
		"article-cat-331": "Minuto Qobuz",
		"article-cat-332": "Moderno",
		"article-cat-333": "Newsletters",
		"article-cat-334": "Newsletter Qobuz Semanal",
		"article-cat-335": "Newsletter Promoções",
		"article-cat-336": "Newsletter Qobuz Hi-Fi",
		"article-cat-337": "Newsletter Clássico",
		"article-cat-339": "Newsletter Eletrônico",
		"article-cat-340": "Newsletter Infantil",
		"article-cat-341": "Newsletter Recitação",
		"article-cat-342": "Smartphones compatíveis com áudio-HD",
		"article-cat-343": "Newsletter Chanson Française",
		"article-cat-344": "France Musique",
		"article-cat-345": "Estilo Moderno",
		"article-cat-347": "Newsletter Ambiente",
		"article-cat-350": "Em inglês",
		"article-cat-351": "Em alemão",
		"article-cat-352": "Em holandês",
		"article-cat-353": "Em inglês",
		"article-cat-354": "Em alemão",
		"article-cat-355": "Em holandês",
		"article-cat-356": "Em holandês",
		"article-cat-357": "Em alemão",
		"article-cat-358": "Em inglês",
		"article-cat-359": "Vieux Sequins et Vieilles Cuirasses",
		"article-cat-360": "Hannah Krooz",
		"article-cat-361": "Tutoriais",
		"article-cat-362": "Novidades da Música Clássica",
		"article-cat-363": "Studio Qobuz",
		"article-cat-364": "Qobuz Studio",
		"article-cat-365": "Story",
		"article-cat-368": "Arquivos",
		"article-cat-369": "Qobuz Chef",
		"article-cat-370": "One Cover / One Word"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/apiLocale/apiPt.json
// module id = 562
// module chunks = 0